<template>
    <div class="detail">
        <el-dialog title="详情" :visible.sync="dialogVisible" width="576px">
            <div class="content">
                <el-form ref="form" :model="form" label-width="120px" label-position="left">
                    <el-form-item label="产品名称：">
                        <p>{{ form.product_name }}</p>
                    </el-form-item>
                    <el-form-item label="品牌名称：">
                        <p>{{ form.brand_name }}</p>
                    </el-form-item>
                    <el-form-item label="商品分类：">
                        <p>{{ form.category_name }}</p>
                    </el-form-item>
                    <el-form-item label="经销商名称：">
                        <p>{{ form.agency_name }}</p>
                    </el-form-item>
                    <el-form-item label="产品名单类型：">
                        <p>{{ form.type == 1 ? "普通授权" : form.type == 2 ? "白名单" : "黑名单" }}</p>
                    </el-form-item>
                    <el-form-item label="销售价：">
                        <p>{{ form.sale_price }}</p>
                    </el-form-item>
                    <el-form-item label="上限价：">
                        <p>{{ form.price_top }}</p>
                    </el-form-item>
                    <el-form-item label="下限价：">
                        <p>{{ form.price_bottom }}</p>
                    </el-form-item>
                    <el-form-item label="状态：">
                        <p>
                            {{ form.status == 1 ? "正常" : form.status == 2 ? "停权" : "禁售"
                            }}<span v-if="form.status == 3">{{ form.forbidsale_type == 1 ? "（禁止该经销商售卖）" : "（禁止该产品售卖）" }}</span>
                        </p>
                    </el-form-item>
                    <el-form-item label="原因：" v-if="form.forbid_the_sale_reason">
                        <p>{{ form.forbid_the_sale_reason }}</p>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" size="medium" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import Qs from "qs";
export default {
    data() {
        return {
            dialogVisible: false,
            form: {
                product_name: "",
                brand_name: "",
                category_name: "",
                agency_name: "",
                sale_price: "",
                price_top: "",
                price_bottom: "",
                status: "",
                forbid_the_sale_reason: "",
                type: "",
            },
            // formLoad: false,
        };
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    mounted() {},
    created() {},
    methods: {
        ...mapActions({
            productDetail: "brand/getAgencyProductDetail",
        }),
        getTable(id) {
            // this.formLoad = true;
            let opt = {
                token: this.getToken,
                id: id,
            };
            this.productDetail(opt).then(({ data }) => {
                // this.formLoad = false;
                if (data.code == 1) {
                    this.form = data.data;
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.detail {
    .content {
        max-height: 500px;
        overflow-y: auto;
        &::-webkit-scrollbar-track-piece {
            background: #d3dce6;
        }

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: #99a9bf;
            border-radius: 20px;
        }
    }
}
</style>